import { withInstall } from "../../utils/install";
import GeoMark from "./src/geoMark.vue";

export * from "./src/geoMark";

export const IGeoMark = withInstall(GeoMark); // 增加类型

export default IGeoMark;
